import { createServerFn } from "@tanstack/react-start";
import { eq } from "drizzle-orm";
import z from "zod";
import { db } from "~/db";
import { account, user } from "~/db/schema";

const checkAuthAccountsSchema = z.object({
  email: z.email(),
});

export const checkAuthAccounts = createServerFn({ method: "POST" })
  .inputValidator(checkAuthAccountsSchema)
  .handler(async (ctx) => {
    const { email } = ctx.data;

    const accounts = await db
      .select({
        accountId: account.accountId,
        providerId: account.providerId,
        password: account.password,
        userId: account.userId,
        email: user.email,
        createdAt: account.createdAt,
      })
      .from(account)
      .innerJoin(user, eq(account.userId, user.id))
      .where(eq(user.email, email));

    const providers = accounts.map((a) => a.providerId);

    const hasCredentialAccount = accounts.some(
      (a) => a.providerId === "credential",
    );
    const credentialAccountWithoutPassword = accounts.some(
      (a) => a.providerId === "credential" && !a.password,
    );

    let result:
      | { found: false }
      | {
          found: true;
          provider: "google";
          needsPasswordSetup: false;
        }
      | {
          found: true;
          provider: "email";
          needsPasswordSetup: boolean;
        };

    if (providers.length === 0) {
      result = { found: false };
    } else if (providers.length === 1 && providers.includes("google")) {
      result = { found: true, provider: "google", needsPasswordSetup: false };
    } else {
      result = {
        found: true,
        provider: "email",
        // Migrated users can have credential accounts without a stored password hash.
        needsPasswordSetup:
          hasCredentialAccount && credentialAccountWithoutPassword,
      };
    }

    return result;
  });
